/*
|--------------------------------------------------------------------------
| Mutation Types
|--------------------------------------------------------------------------
*/
export const SET_REFERENCE = 'SET_REFERENCE';
export const UNSET_REFERENCE = 'UNSET_REFERENCE';

/*
|--------------------------------------------------------------------------
| Initial State
|--------------------------------------------------------------------------
*/
const initialState = {
    malaysia_states: null,
    countries: null,
    country_phone_codes: null,
    business_industries: null,
    banks: null,
    loan_categories: null,
};

/*
|--------------------------------------------------------------------------
| Mutations
|--------------------------------------------------------------------------
*/
const mutations = {
    [SET_REFERENCE](state, payload) {
        state.malaysia_states = payload.references.malaysia_states;
        state.countries = payload.references.countries;
        state.country_phone_codes = payload.references.country_phone_codes;
        state.business_industries = payload.references.business_industries;
        state.banks = payload.references.banks;
        state.loan_categories = payload.references.loan_categories;
    },
    [UNSET_REFERENCE](state, payload) {
        state.malaysia_states = null;
        state.countries = null;
        state.country_phone_codes = null;
        state.business_industries = null;
        state.loan_categories = null;

    }
};

/*
|--------------------------------------------------------------------------
| Actions
|--------------------------------------------------------------------------
*/
const actions = {
    setReferences: (context, references) => {
        context.commit(SET_REFERENCE, {references})
    },

    unsetReferences: (context) => {
        context.commit(UNSET_REFERENCE);
    }
};

/*
|--------------------------------------------------------------------------
| Getters
|--------------------------------------------------------------------------
*/
const getters = {
    getReferences: (state) => {
        return state;
    }
};

/*
|--------------------------------------------------------------------------
| Export the module
|--------------------------------------------------------------------------
*/
export default {
    state: initialState,
    mutations,
    actions,
    getters
}
